export default "__VITE_ASSET__BpV4$05C__"